export const tr = {
    campaign_broad_match_goal_all: 'Tüm hedeflere göre dönüşüm optimizasyonu',
    campaign_broad_match_goal_changed: 'Dönüşüm optimizasyonu: {oldgoal} {newgoal}',
    campaign_broad_match_goal_id: '"{goalName}" hedefine göre dönüşüm optimizasyonu',
    campaign_broad_match_limit: 'Kampanyanın maksimum harcama sınırı, toplam harcamasının %{limit} kadarı',
    campaign_broad_match_limit_changed:
        'Kampanyanın maksimum harcama sınırı, toplam harcamasının {oldLimit} {newLimit} kadarı',
    'on-all-goals': 'tüm hedeflere göre',
    'on-goal': '{goalName} hedefine göre'
};
